import React from 'react'
import ReactDOM from 'react-dom/client'
import { AnimatePresence } from 'framer-motion'
import App from './App.jsx'
import './index.css'
import { TranslateProvider } from "./context/TranslateCtx.jsx"

/* ── Cookie-Consent Context & Analytics Loader ───────── */
import { CookieConsentProvider } from './context/CookieConsentContext.jsx'
import AnalyticsLoader from './components/AnalyticsLoader.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <TranslateProvider>
      {/* เปิด/ปิดคุกกี้ + Banner */}
      <CookieConsentProvider>
        {/* page-transition */}
        <AnimatePresence mode="wait">

          <App />

          {/* <AnalyticsLoader /> */}
        </AnimatePresence>
      </CookieConsentProvider>
    </TranslateProvider>
  </React.StrictMode>
)
